import _ from 'lodash';
import { AngularServices, getAngularService } from '../../core';
export default function getContextRoomId() {
    const roomHelpersFactory = getAngularService(AngularServices.RoomHelpersFactory);
    return _.get(roomHelpersFactory.getRoom(), 'id', null);
}
